/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsAuthUserLoginInput } from "../../entities/models/AuthUserLoginInput";
import { z } from "zod/v4";

export const modelsAuthUserLoginInputSchema = z.object({
    "password": z.string(),
"phone_number": z.string()
    }) as unknown as z.ZodType<ModelsAuthUserLoginInput>